/* Basics Life — COMPLETE THE LOOK in the cart drawer.
 * Built to the Website Rulebook, section "Cart drawer", rules #187-#204,
 * all decided by Suhail on 16 Sep 2026. Installed in theme
 * "Suhail cart work 16 september" (201421127761).
 *
 * WHAT THIS REPLACES. The old row in bl-cart-drawer.js picked products by
 * OFFER TIER: it took the gap to the next discount tier, turned that into a
 * price band, and showed SALE products inside the band. So a man holding a
 * shirt was shown two t-shirts at 839 because 839 bridged the gap — not
 * because they went with the shirt (rule 188).
 *
 * WHAT IT DOES INSTEAD. It ASKS THE WORKER (/apps/chat/pair), which holds
 * Suhail's word-for-word approved colour pairings — the same COMBO_ADVICE
 * table that answers "black shirt combination" in the chat, so the cart and
 * the chat can never recommend different trousers for the same shirt.
 *
 * TWO THINGS THE THEME DELIBERATELY DOES NOT DO:
 *   • Hold its own copy of the colour matching. A hard-coded list keeps
 *     showing a trouser that sold out this morning; the worker refuses
 *     anything unbuyable.
 *   • Read colour from the product title. "Cloud Grey" is tagged
 *     COLOUR:BLACK — a title-reader pairs the wrong trousers.
 *
 * The old row is disabled by markup, not by deletion: its renderRecommended()
 * needs .bl-cartdrawer__rec-title, and the snippet now names that element
 * .bl-cartdrawer__ctl-title, so it returns at its own guard without touching
 * anything. bl-cart-drawer.js is left exactly as the dev wrote it.
 */
(function () {
  if (window.__BL_CTL_INIT__) return;
  window.__BL_CTL_INIT__ = true;

  var ENDPOINT = '/apps/chat/pair';
  var seq = 0;          // guards a slow answer from landing after a newer cart
  var lastKey = '';     // don't re-ask the worker for a cart that hasn't changed

  // Tops pair with bottoms and vice versa. Normalised to letters+digits so
  // "T.SHIRTS" — the real product_type in this catalogue — matches TSHIRTS.
  var TOP_PT = { SHIRTS: 1, TSHIRTS: 1, TSHIRT: 1, POLOTSHIRTS: 1, POLOS: 1, JACKETS: 1, JACKET: 1, SWEATSHIRTS: 1 };
  var BOTTOM_PT = { TROUSERS: 1, JEANS: 1, SHORTS: 1 };

  function normPt(s) {
    return String(s || '').toUpperCase().replace(/[^A-Z0-9]/g, '');
  }

  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  // Indian grouping — 1399 -> ₹1,399 and 123456 -> ₹1,23,456.
  function money(rupees) {
    var n = Math.round(Number(rupees) || 0);
    try { return '₹' + n.toLocaleString('en-IN'); }
    catch (e) { return '₹' + String(n); }
  }

  // The size the customer actually chose. /cart.js carries it and the worker
  // cannot know it — without it we would suggest trousers he cannot buy.
  function sizeOf(item) {
    var owv = item.options_with_values || [];
    for (var i = 0; i < owv.length; i++) {
      var ov = owv[i] || {};
      if (String(ov.name || '').toLowerCase().trim() === 'size' && ov.value) {
        return String(ov.value).toUpperCase().trim();
      }
    }
    // Fallback: the variant title's last segment — "BEIGE / 32" -> "32".
    var bits = String(item.variant_title || '').split('/');
    return bits.length ? bits[bits.length - 1].toUpperCase().trim() : '';
  }

  // RULE 196: the worker never sees the customer, so the personalised heading
  // is assembled here. Only a name that LOOKS like a name is printed — an
  // empty or junk first_name must never reach a heading above the checkout
  // button.
  function heading(root, pair) {
    var raw = String(root.getAttribute('data-customer-first-name') || '').trim();
    if (/^[A-Za-z][A-Za-z'.\- ]{0,20}$/.test(raw) && pair && pair.headingSignedIn) {
      return {
        text: pair.headingSignedIn.replace('{name}', raw.charAt(0).toUpperCase() + raw.slice(1)),
        personal: true
      };
    }
    return { text: (pair && pair.headingGuest) || 'COMPLETE THE LOOK', personal: false };
  }

  // THE PERSONALISED HEADING MUST NOT BE SHOUTED. The drawer's heading style is
  // uppercase with wide tracking, which is right for the guest heading — the
  // worker sends that already capitalised as "COMPLETE THE LOOK". But Suhail's
  // approved copy for a signed-in customer is "Complete the look, Suhail" in
  // sentence case (rule 196), and letting the CSS uppercase it turns a warm
  // greeting into shouting a customer's own name back at him. So the transform
  // and the wide tracking are switched off for that one case only, and restored
  // for the guest heading.
  function applyHeading(el, h) {
    el.textContent = h.text;
    el.style.textTransform = h.personal ? 'none' : '';
    el.style.letterSpacing = h.personal ? '0.02em' : '';
  }

  // RULE 200: the purchase now completes on the product page, so the cart is
  // marked at the MOMENT OF THE TAP — not on add. keepalive so the request
  // survives the navigation away. Without this the row gets no credit for the
  // sale it caused and there is nothing to judge in a month.
  function markCart(mark) {
    try {
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        credentials: 'same-origin',
        keepalive: true,
        body: JSON.stringify({ attributes: { bb_pair: mark || 'bb_pair' } })
      })['catch'](function () {});
    } catch (e) {}
  }

  // RULE 200: a card is a LINK, never an add-to-cart button — no size picker in
  //   the drawer, because the M-to-32 map is an assumption about his body and a
  //   wrong guess comes back as a return, which costs more than the sale.
  // RULE 204: sale price with the original struck beside it. No percentage, and
  //   never a strike-through equal to the price — the worker sends
  //   compareAtPrice as null unless the discount is real, so a fake strike
  //   cannot happen here.
  // RULE 201: the "with your black shirt" tag prints only when the worker sent
  //   one, which is only when the cards came from 2+ of his garments.
  function cardHtml(card) {
    if (!card || !card.url) return '';
    var img = card.image_url || '';
    var title = esc(card.title || '');
    var price = Number(card.price) || 0;
    var mrp = Number(card.compareAtPrice) || 0;
    return '<a class="bl-cartdrawer__rec-card bl-cartdrawer__rec-link" href="' + esc(card.url) + '" data-bb-pair="1">' +
        '<div class="bl-cartdrawer__rec-img">' +
          (img ? '<img src="' + esc(img) + '" alt="' + title + '" loading="lazy">' : '') +
        '</div>' +
        '<div class="bl-cartdrawer__rec-name">' + title + '</div>' +
        '<div class="bl-cartdrawer__rec-price">' +
          '<span class="bl-cartdrawer__rec-price-now">' + money(price) + '</span>' +
          (mrp > price ? '<span class="bl-cartdrawer__rec-price-mrp">' + money(mrp) + '</span>' : '') +
        '</div>' +
        (card.withLabel ? '<div class="bl-cartdrawer__ctl-with">' + esc(card.withLabel) + '</div>' : '') +
      '</a>';
  }

  function parts(root) {
    var wrap = root.querySelector('.bl-cartdrawer__rec');
    if (!wrap) return null;
    return {
      wrap: wrap,
      row: wrap.querySelector('.bl-cartdrawer__rec-row'),
      title: wrap.querySelector('.bl-cartdrawer__ctl-title')
    };
  }

  function clearLine(wrap) {
    var old = wrap.querySelector('.bl-cartdrawer__ctl-line');
    if (old && old.parentNode) old.parentNode.removeChild(old);
  }

  function render(root, cart) {
    var p = parts(root);
    if (!p || !p.row || !p.title) return;
    var items = (cart && cart.items) || [];
    if (!items.length) { p.wrap.hidden = true; return; }

    // THE ROW STAYS WHEN THE OUTFIT IS COMPLETE — this replaces rule 203.
    // Suhail, 17 Sep 2026, after testing it: "if the complete the look feature
    // is working then why remove it. The consumer can ignore it if he wants."
    // It used to hide here and never ask. What that did in practice was make a
    // whole section of the drawer vanish at the moment the customer did the
    // thing we wanted — which is not the same as not nagging him.
    // We still work out whether the cart is already an outfit, but now only to
    // choose the right PLACEHOLDER heading while the worker answers.
    var hasTop = false, hasBottom = false;
    items.forEach(function (it) {
      var pt = normPt(it.product_type);
      if (BOTTOM_PT[pt]) hasBottom = true;
      else if (TOP_PT[pt]) hasTop = true;
    });
    var complete = hasTop && hasBottom;

    var ask = [];
    items.slice(0, 6).forEach(function (it) {
      var id = it.product_id;
      if (id) ask.push(String(id) + ':' + sizeOf(it));
    });
    if (!ask.length) { p.wrap.hidden = true; return; }

    var key = ask.join(',');
    if (key === lastKey && p.row.children.length && !p.wrap.hidden) return;  // nothing changed
    lastKey = key;

    // RULE 203: the heading and "Finding products…" appear immediately, then
    // the styling line and the cards replace the text.
    var mine = ++seq;
    // Reset to the guest heading while loading — otherwise a previous render's
    // personalised styling would linger on the caps heading.
    // A COMPLETE CART GETS A BLANK PLACEHOLDER, NOT "COMPLETE THE LOOK". The
    // heading it ends up with names the trousers he is holding, and only the
    // worker knows their colour — so printing the old heading here would flash
    // a false promise for as long as the request takes.
    applyHeading(p.title, { text: complete ? '' : 'COMPLETE THE LOOK', personal: false });
    clearLine(p.wrap);
    p.row.innerHTML = '<div class="bl-cartdrawer__rec-loading">Finding products…</div>';
    p.wrap.hidden = false;

    fetch(ENDPOINT + '?items=' + encodeURIComponent(key), {
      headers: { 'Accept': 'application/json' },
      credentials: 'same-origin'
    })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (res) {
        if (mine !== seq) return;                 // a newer cart already asked
        // The worker wraps its answer as { ok: true, pair: {...} | null } —
        // read through that envelope, never off the top level.
        var pair = res && res.pair;
        // RULE 197: nothing rather than something wrong. We deliberately do
        // NOT fall back to Shopify's recommendation algorithm — putting a
        // styling heading over suggestions that know nothing about style is
        // the exact fault this replaces.
        if (!pair || !pair.cards || !pair.cards.length) { p.wrap.hidden = true; lastKey = ''; return; }
        var html = pair.cards.slice(0, 4).map(cardHtml).join('');
        if (!html) { p.wrap.hidden = true; lastKey = ''; return; }

        applyHeading(p.title, heading(root, pair));
        p.row.innerHTML = html;
        // RULE 191 + RULE 199: the ANCHOR's approved line, word for word,
        // never trimmed to match the cards. It sits between the heading and
        // the row.
        clearLine(p.wrap);
        if (pair.line) {
          p.row.insertAdjacentHTML('beforebegin',
            '<div class="bl-cartdrawer__ctl-line">' + esc(pair.line) + '</div>');
        }
        p.wrap.hidden = false;
        Array.prototype.forEach.call(p.row.querySelectorAll('[data-bb-pair]'), function (a) {
          a.addEventListener('click', function () { markCart(pair.mark); });
        });
      })
      ['catch'](function () {
        // No error text ever reaches a customer standing at the checkout button.
        if (mine === seq) { p.wrap.hidden = true; lastKey = ''; }
      });
  }

  var pending = null;
  function refresh(root) {
    if (pending) clearTimeout(pending);
    pending = setTimeout(function () {
      pending = null;
      fetch('/cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (cart) { if (cart) render(root, cart); })
        ['catch'](function () {});
    }, 120);
  }

  function start() {
    var root = document.getElementById('blCartDrawerRoot');
    if (!root) return;
    var p = parts(root);
    if (!p || !p.row || !p.title) return;   // snippet not updated yet — do nothing

    // Trigger 1: the drawer opening. The drawer sets is-open / aria-hidden on
    // the root, which is what the theme's own tracking watches too.
    if (window.MutationObserver) {
      var wasOpen = false;
      new MutationObserver(function () {
        var open = root.classList.contains('is-open') || root.getAttribute('aria-hidden') === 'false';
        if (open && !wasOpen) { wasOpen = true; refresh(root); }
        else if (!open) { wasOpen = false; }
      }).observe(root, { attributes: true, attributeFilter: ['class', 'aria-hidden'] });

      // Trigger 2: the line items changing while the drawer is open — a
      // quantity edit or a remove can turn a top-only cart into an outfit, or
      // back again, and the row must follow.
      var itemsWrap = root.querySelector('.bl-cartdrawer__items');
      if (itemsWrap) {
        new MutationObserver(function () { refresh(root); })
          .observe(itemsWrap, { childList: true });
      }
    }

    // Trigger 3: the snippet is also rendered into the /cart page, where the
    // drawer never "opens".
    if (document.body && document.body.classList.contains('template-cart')) refresh(root);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
